import React from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import Grid from '@material-ui/core/Grid';
import DraggableDialogPaperComponent from '../../common/components/DraggableDialogPaperComponent';
import InjectStore from '../../common/utils/InjectStore';
import { Typography, Switch, Tooltip } from '@material-ui/core';
import ParserSummary from '../components/ParserSummary';
import { Box } from '@material-ui/core';
import DeleteIcon from '@material-ui/icons/Delete'

class ParsersListDialog extends React.Component {

  handleNext = () => {
    this.props.store.showMapFieldsDialog();
  }

  render () {
    const { store } = this.props;

    return (
      <Dialog
        open={store.currentState == "parsers-list"}
        // onClose={handleClose}
        PaperComponent={DraggableDialogPaperComponent}
        aria-labelledby="draggable-dialog-title"
        maxWidth={"md"}
        fullWidth={true}
      >
        <DialogTitle style={{ cursor: 'move' }} id="draggable-dialog-title">
          Fetch From Email
        </DialogTitle>
        <DialogContent>
          <Grid
            item
            container
            direction="row"
            justify="space-between"
            alignItems="center"
          >
            <Grid
              item
              xs
            >
              <Typography variant="body1">{store.currentData.email_id}</Typography>
            </Grid>
            <Tooltip title="click to edit">
              <Box
                variant="body2"
                fontStyle="italic"
                onClick={store.showEmailFrequencyDialog}
                className={"email_frequency_text"}
              >
                {"Runs " + store.getCurrentEmailFrequencyLabel()}
              </Box>
            </Tooltip>
            <Tooltip title={store.currentData.is_disabled == "0" ? "Pause email fetch" : "Start email fetch"}>
              <Switch
                checked={store.currentData.is_disabled == "0"}
                onChange={(ev) => {
                  store.handleDisable(!ev.target.checked ? 1 : 0)
                }}
                xs={1}
              ></Switch>
            </Tooltip>
            <DeleteIcon
              className="menu_button_inside"
              aria-haspopup="true"
              onClick={store.handleDelete}
              xs={1}
            />
          </Grid>
          {/* <Grid container spacing={3}> */}
          <ParserSummary />
          {/* </Grid> */}
        </DialogContent>
        <DialogActions>
          <Button variant="contained" color="primary" onClick={() => store.handleTestParserButtonClick()}>
            Test Parser
          </Button>
          <Button variant="contained" color="primary" onClick={store.handleAddTemplate}>
            Add Additional Parser
          </Button>
          <Button onClick={store.handleClose.bind(store, false)} color="primary">
            Close
          </Button>
        </DialogActions>
      </Dialog>
    );
  }

}

export default InjectStore(ParsersListDialog);
